import { render, staticRenderFns } from "./allSearch.vue?vue&type=template&id=8f537bf2&scoped=true"
import script from "./allSearch.vue?vue&type=script&lang=js"
export * from "./allSearch.vue?vue&type=script&lang=js"
import style0 from "./allSearch.vue?vue&type=style&index=0&id=8f537bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f537bf2",
  null
  
)

export default component.exports